import "./_layout.scss";

import {ReactElement} from "react";
import {useState} from "react";
import {appIcon} from "types/application";

import iconArrow from "@/assets/iconArrow.svg";
import AppIcon from "@/components/AppIcon/AppIcon";
import Loader from "@/components/Loader/loader";
import Tooltips from "@/components/Tooltips/Tooltips";

function Aside({
  applications,
}: {
  applications: appIcon[] | undefined;
}): ReactElement {
  const defaultTooltipsInfo = {message: "", rigth: 0, isVisible: false};
  const [tooltipsInfo, setTooltipsInfo] = useState<{
    message: string;
    rigth: number;
    isVisible: boolean;
  }>(defaultTooltipsInfo);

  const AllAppIcon: ReactElement[] | undefined = applications?.map(
    (app: appIcon, index) => {
      return (
        <AppIcon
          application={app}
          key={`${index}_${app.nom}`}
          onMouseOver={() => {
            setTooltipsInfo({
              message: app?.description || "",
              rigth: 120,
              isVisible: true,
            });
          }}
          onMouseOut={() => {
            setTooltipsInfo(defaultTooltipsInfo);
          }}
        />
      );
    },
  );

  return (
    <div className="content">
      <div className="relative">
        <Tooltips
          tooltipMessage={tooltipsInfo.message}
          bottom={20}
          left={"30%"}
          isVisible={tooltipsInfo.isVisible}
        />
      </div>
      <aside className="content-app bg-grey iconList">
        <div className="circle-icon">
          <img src={iconArrow} alt="icon flêche" />
          <p> Application cofaq</p>
          <img src={iconArrow} alt="icon flêche" />
        </div>
        <div className="content-app--carousel">
          {AllAppIcon ? AllAppIcon : <Loader />}
        </div>
      </aside>
    </div>
  );
}

export default Aside;
